export default __webpack_public_path__ + "static/media/checkOwner.24640848.svg";